import React from "react";
import { Card, Col, Progress, Space, Statistic, Tag, Typography } from "antd";
import { transformSingleResponseData } from "../../../../utils/surveys";

const QuestionResponsesNPS = ({ question }) => {
    const npsClasses = [
        { label: "Promoters", min: 9, max: 10 },
        { label: "Passives", min: 7, max: 8 },
        { label: "Detractors", min: 0, max: 6 },
    ];

    const transformNPSQuestion = () => {
        const npsTransformedResponses = [];

        for (const res of question?.responses) {
            npsClasses.forEach((classEl) => {
                if (res?.answer <= classEl.max && res?.answer >= classEl.min) {
                    npsTransformedResponses.push({
                        id: res?.id,
                        answer: classEl.label,
                    });
                }
            });
        }

        return { ...question, responses: npsTransformedResponses };
    };

    const calculateNPS = () => {
        return (
            (transformSingleResponseData(transformNPSQuestion(), "Promoters")
                .overallPercentage || 0) -
            (transformSingleResponseData(transformNPSQuestion(), "Detractors")
                .overallPercentage || 0)
        );
    };

    return (
        <Col span={24}>
            <Card
                bordered={true}
                style={{
                    background: "#fafafa",
                    textAlign: "left",
                }}
            >
                <Typography.Title level={4}>
                    {question.headline}
                </Typography.Title>
                <div
                    style={{
                        marginTop: "20px",
                    }}
                >
                    <Tag color="blue">Net Promoter Score (NPS)</Tag>
                    <Tag color="orange">
                        {question.responses.length} responses
                    </Tag>
                </div>
                <Space
                    direction="vertical"
                    size="large"
                    style={{ marginTop: "50px", width: "100%" }}
                >
                    {npsClasses?.map((classEl) => (
                        <div key={classEl.label}>
                            <Space
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Space size="large">
                                    <Typography>{classEl.label}</Typography>
                                    <Tag bordered={false}>
                                        {transformSingleResponseData(
                                            transformNPSQuestion(),
                                            classEl.label
                                        ).overallPercentage || 0}{" "}
                                        %
                                    </Tag>
                                </Space>
                                <Tag bordered={false}>
                                    {
                                        transformSingleResponseData(
                                            transformNPSQuestion(),
                                            classEl.label
                                        ).count
                                    }{" "}
                                    {transformSingleResponseData(
                                        transformNPSQuestion(),
                                        classEl.label
                                    ).count === 1
                                        ? "response"
                                        : "responses"}
                                </Tag>
                            </Space>
                            <Progress
                                percent={
                                    transformSingleResponseData(
                                        transformNPSQuestion(),
                                        classEl.label
                                    ).overallPercentage
                                }
                                status="active"
                                size="default"
                                showInfo={false}
                            />
                        </div>
                    ))}
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Statistic
                            value={calculateNPS()}
                            precision={2}
                            valueStyle={{
                                color:
                                    calculateNPS() > 0 ? "#3f8600" : "#cf1322",
                            }}
                            prefix={calculateNPS() > 0 ? "+" : ""}
                            suffix="%"
                        />
                    </div>
                </Space>
            </Card>
        </Col>
    );
};

export default QuestionResponsesNPS;
